const LoggedInLayout = () => import("../../views/LoggedInLayout.vue");


const SettingProject = r => require.ensure([], () => r(require('./views/SettingProject.vue')))
//const settingprojectsummary = r => require.ensure([], () => r(require('./views/Summary.vue')))
//const dragsummary = r => require.ensure([], () => r(require('./views/dragsummary.vue')))
//dragsummary

const moduleRoute = {
  path: "/",
  component: LoggedInLayout,
  children: [    
    {
      path: "/settingproject",
      component: SettingProject
    }
    /*
    ,
    {
      path: "/settingprojectsummary",
      component: settingprojectsummary
    }
    ,
    {
      path: "/dragsummary",
      component: dragsummary
    }*/
  ]
};

export default router => {
  router.addRoutes([moduleRoute]);
};
